import type { AvailableGameCatalogEntry } from '../../catalog-entry.js';
import { stripTestDescriptor } from './descriptor.js';

export const stripTestCatalogEntry = {
  descriptor: stripTestDescriptor,
  availability: 'diagnostic',
  load: async () => (await import('./strip-test.js')).stripTestDefinition,
} satisfies AvailableGameCatalogEntry;
